import styled, {DefaultTheme, css} from 'styled-components';

import {mixins} from '../styles';
import {TSize} from '../types';

type TPriceProps = {
  size?: TSize;
  color: keyof DefaultTheme['palette'];
};

export const Currency = styled.span`
  color: ${({theme}) => theme.palette.grey400};
`;

export const Price = styled.span<TPriceProps>`
  flex-shrink: 0;
  ${({color, theme, size}) => css`
    color: ${theme.palette[color]};
    ${size === 'L' && mixins.f8}
    ${size === 'M' && mixins.f6}
    ${size === 'S' && mixins.f4}
    ${Currency} {
      ${size === 'L' && mixins.f6}
      ${size === 'M' && mixins.f4}
      ${size === 'S' && mixins.f2}
    }
  `}
`;
